import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[500px] md:h-[650px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Epic%20gaming%20atmosphere%20with%20warm%20dark%20amber%20and%20crimson%20gradient%20background%2C%20abstract%20geometric%20particles%20floating%2C%20cinematic%20game%20world%20scene%2C%20dramatic%20lighting%20with%20golden%20accents%2C%20immersive%20digital%20art%20style%2C%20mysterious%20and%20exciting%20mood%2C%20no%20text%2C%20clean%20composition%2C%20professional%20game%20website%20hero%20background&width=1800&height=900&seq=hero-bg-gaming-01&orientation=landscape"
        alt="黄游网页版 - 在线畅玩"
        title="黄游网页版 - 在线游戏平台"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/50"></div>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full max-w-[900px] mx-auto px-4 md:px-6 text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-white mb-4 md:mb-6 leading-tight">
            无需下载，即刻畅玩
          </h1>
          <p className="text-base md:text-lg text-white/80 max-w-[650px] mx-auto mb-8 md:mb-10 leading-relaxed">
            黄游网页版为您提供海量精品游戏，打开浏览器即点即玩，PC手机随心切换，随时随地享受极致的在线游戏体验。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/role-playing"
              className="px-8 py-3.5 bg-primary-500 text-white text-base md:text-lg font-medium rounded-md hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              立即开始游戏
            </Link>
            <Link
              to="/about"
              className="px-8 py-3.5 bg-white/15 text-white text-base md:text-lg font-medium rounded-md hover:bg-white/25 transition-all duration-300 backdrop-blur-sm whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>
          <div className="mt-10 md:mt-12 flex items-center justify-center gap-8 flex-wrap">
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-white">200+</p>
              <p className="text-sm text-white/60 mt-1">精品游戏</p>
            </div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-white">500万+</p>
              <p className="text-sm text-white/60 mt-1">活跃玩家</p>
            </div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-white">4.8</p>
              <p className="text-sm text-white/60 mt-1">用户评分</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}